import { Injectable } from '@angular/core';
import { BaseService } from "./base.service";
import { Http } from '@angular/http';
import * as Enum from '../utils/enums';
import { Observable } from "rxjs";
import { RequestBuilder } from '../classes/request-builder';

@Injectable()
export class AccessiService extends BaseService {

    /**
     * Costruttore
     * @param http Servizio di richieste HTTP 
     */
    constructor(http: Http) {
        super(http)
    }

    /**
     * Mezzi e persone di un cantiere
     * @param reqBuilder 
     */
    getCantiereData(reqBuilder: RequestBuilder): Observable<any> {
        return this.doPost('entitaCantiere/fetch', reqBuilder, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
    }

    /**
     * Get accessi di un mezzo
     * @param reqBuilder 
     */
    getAccessiMezzo(reqBuilder: RequestBuilder): Observable<any> {
        return this.doPost('mezzo/fetchSingle', reqBuilder, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
    }

    /**
     * Get accessi di una persona
     * @param reqBuilder 
     */
    getAccessiPersona(reqBuilder: RequestBuilder): Observable<any> {
        return this.doPost('persona/fetchSingle', reqBuilder, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
    }

    /**
     * Save  di tutti gli accessi di una persona o di un mezzo
     * @param reqBuilder 
     */
    saveAllAccessi(reqBuilder: RequestBuilder): Observable<any> {
        return this.doPost('accesso/saveAll', reqBuilder, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
    }

    /**
     * Get del codice QR per il mezzo o per la persona
     * @param reqBuilder 
     */
    getQRCode(reqBuilder: RequestBuilder): Observable<any> {
        return this.doPost('QRCode/getQRCodeString', reqBuilder, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
    }

    /**
     * fetch variazione accessi 
     * @param reqBuilder 
     */
    fetchVariazioneAccessi(reqBuilder: RequestBuilder): Observable<any> {
        return this.doPost('variazioneAccesso/fetch', reqBuilder, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
    }


    /**
     * Get dei codici QR per il cantiere
     * @param reqBuilder 
     */
    getQRCodeZip(reqBuilder: RequestBuilder): Observable<any> {
        return this.doPost('QRCode/getQRCodeZip', reqBuilder, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
    }


    /**
     * export accessi settimanali file
     * @param reqBuilder 
     */
    getAccessiSettimanali(reqBuilder: RequestBuilder): Observable<any> {
        return this.doPost('accesso/exportAccessiSettimanali', reqBuilder, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
    }

    /**
     * get aziende senza accessi
     * @param reqBuilder 
     */
    getAziendeSenzaAccessi(reqBuilder: RequestBuilder): Observable<any> {
        return this.doPost('accesso/getAziendeSenzaAccessi', reqBuilder, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
    }

    /**
     * get all SITI (accessi)
     * @param reqBuilder 
     * @returns 
     */
    getAllSiti(reqBuilder: RequestBuilder): Observable<any> {
        return this.doPost('sito/fetch', reqBuilder, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON);
    }

    /**
     * save di tutti gli accessi da parte del referente
     * @param reqBuilder 
     */
    saveIngressoAccessi(reqBuilder: RequestBuilder): Observable<any> {
        return this.doPost('accesso/updateAll', reqBuilder, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
    }
}